import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaBusAlt, FaTruck, FaUserShield, FaClock, FaTools, FaGlobe } from 'react-icons/fa';
import bags from '../images/bags.jpg';
import forgiens from '../images/forgiens.png'
import haj from '../images/haj.png'
import passengers from '../images/passengers.jpg';
import clock from '../images/clock.png';
import tools from '../images/tools.png';

const services = [
    {
        image: passengers,
        icon: <FaBusAlt className="text-blue-600 text-4xl mb-4" />,
        titleKey: "passengerTransport",
        descKey: "passengerTransportDesc",
    },
    {
        image: bags,
        icon: <FaTruck className="text-blue-600 text-4xl mb-4" />,
        titleKey: "cargoTransport",
        descKey: "cargoTransportDesc",
    },
    {
        image: forgiens,
        icon: <FaUserShield className="text-blue-600 text-4xl mb-4" />,
        titleKey: "vipService",
        descKey: "vipDesc",
    },
    {
        image: haj,
        icon: <FaUserShield className="text-blue-600 text-4xl mb-4" />,
        titleKey: "hajService",
        descKey: "hajDesc",
    },
    {
        image: clock,
        icon: <FaClock className="text-blue-600 text-8xl mb-4" />,
        titleKey: "onTime",
        descKey: "onTimeDesc",
    },
    {
        image: tools,
        icon: <FaTools className="text-blue-600 text-8xl mb-4" />,
        titleKey: "fleetMaintenance",
        descKey: "fleetMaintenanceDesc",
    },
    // {
    //     icon: <FaGlobe className="text-blue-600 text-4xl mb-4" />,
    //     titleKey: "regionalService",
    //     descKey: "regionalServiceDesc",
    // }
];

const OurServices = () => {
    const { t } = useTranslation();

    return (
        <div id="services" className="min-h-center flex flex-col"  >
            <main className="flex-grow">
                <header className="max-w-5xl mx-auto text-center py-10 px-4 sm:px-0">
                    <h1 className="text-3xl font-bold text-center mb-8 text-blue-600">
                        {t('ourServices')}
                    </h1>
                </header>
                <div className="max-w-7xl mx-auto text-center">

                    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
                        {services.map((service, idx) => (
                            <div key={idx} className="bg-white p-4 rounded-lg shadow hover:shadow-lg transition">
                                <div className="flex flex-col items-center text-center">
                                    {!service.image && service.icon}
                                    {service.image && <img src={service.image} alt='' style={{ width: '110px' }} />}
                                    <h3 className="text-xl font-semibold mb-2 text-blue-800">{t(service.titleKey)}</h3>
                                    <p className="text-gray-600">{t(service.descKey)}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </main>
        </div>
    );
};

export default OurServices;
